module.exports = __webpack_public_path__ + "img/0.50d3a8ee.png";